import { Record } from 'immutable';

const TransactionRecord = Record({
  eventId: null,
  firstName: null,
  lastName: null,
  roomRate: null,
  roomRateCurrency: null,
  checkInDate: null,
  checkOutDate: null,
  roomType: null,
  confirmation: null,
  nights: null,
  revenue: null,
  commission: null,
  commissionPercentage: null,
  eventReservationId: null,
  status: null,
  source: null,
  eventRsvpId: null,
  chainCode: null,
  brandCode: null,
  property: null,
  ratePlanCode: null,
  paymentRecordNumber: null,
  rooms: null,
  roomNights: null,
  groupCode: null,
  payViaGp: true,
  eventPaymentId: null,
  eventPartyId: null
});

export class Transaction extends TransactionRecord {
  confirmation: string;
  firstName: string;
  lastName: string;
  checkInDate: string;
  checkOutDate: string;
  nights: number;
  roomType: string;
  roomRate: number;
  revenue: number;
  commission: number;
  commissionPercentage: number;
  eventId: number;
  roomRateCurrency: string;
  payViaGp: boolean;
  eventPaymentId: boolean;
  eventPartyId: number;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/transaction.ts